import { FETCH_LOCATIONS, FETCH_LOCATIONS_SUCCESS, FETCH_LOCATIONS_ERROR, SELECT_ALL_LOCATIONS, SELECT_LOCATION_ROW, CREATE_LOCATION, CREATE_LOCATION_SUCCESS,
  CREATE_LOCATION_ERROR, FETCH_USER_LOCATIONS, FETCH_USER_LOCATIONS_SUCCESS, FETCH_USER_LOCATIONS_ERROR, ADD_LOCATIONS_TO_PARENT, ADD_LOCATIONS_TO_PARENT_SUCCESS,
  ADD_LOCATIONS_TO_PARENT_ERROR, REMOVE_LOCATIONS, REMOVE_LOCATIONS_SUCCESS, REMOVE_LOCATIONS_ERROR, UPDATE_LOCATION_SEARCH, FETCH_USER_LOCATIONS_ROLES,
  FETCH_USER_LOCATIONS_ROLES_SUCCESS, FETCH_USER_LOCATIONS_ROLES_ERROR, UPDATE_LOCATION_FILTERS, SET_CURRENT_LOCATION, EDIT_LOCATION, EDIT_LOCATION_SUCCESS,
  EDIT_LOCATION_ERROR, SET_LOCATION_SYSTEM_MODE_BULK, SET_LOCATION_SYSTEM_MODE_BULK_SUCCESS, INCREMENT_LOCATION_PAGE, REINIT_LOCATION_PAGE_COUNT,
  FETCH_LOCATIONS_FACETS, FETCH_LOCATIONS_FACETS_SUCCESS, FETCH_LOCATIONS_FACETS_ERROR, UPDATE_SHOW_LOCATION_FILTERS,
  SET_SINGLE_SELECT_LOCATION, REMOVE_SINGLE_SELECT_LOCATION,
  CREATE_BULK_UNITS, CREATE_BULK_UNITS_REQUEST, CREATE_BULK_UNITS_SUCCESS, CREATE_BULK_UNITS_ERROR,
} from '../constants/ActionTypes';
import { CustomAction, LocationFacetsState } from 'model/state';
import { Location, LocationType, LocationFilters, SystemMode, LocationFacet, ThresholdSetting, AlarmSettings } from 'model';


/**
 * Payload
 */
export interface LocationPayload {
  parentId?: string;
  locations?: Location[];
  userId?: string;
  selectAll?: boolean;
  select?: boolean;
  locationId?: string;
  location?: Location;
  parentType?: LocationType;
  parent?: Location | null;
  search?: string;
  authUserId?: string;
  currentUserId?: string;
  filters?: LocationFilters;
  currentLocation?: Location | null;
  revertMinutes?: number;
  systemModeTarget?: SystemMode;
  changedLocationId?: string;
  changedLocationIds?: string[];
  newMode?: SystemMode;
  types?: LocationType[];
  page?: number;
  total?: number;
  facet?: LocationFacet;
  facetValues?: LocationFacetsState;
  show?: boolean;
  withRoles?: boolean;
  partialLocation?: Partial<Location>;
  locationIds?: string[];
  sort?: string[];
  cached?: boolean;
  settings?: ThresholdSetting; 
  alarmId?: number; 
  alarmSettingsPayload?: AlarmSettings; 
  unitNames?: string[];
}

/**
 * Actions
 */
export const fetchLocations = (userId: string, page: number, parentId: string | undefined, search: string, filters: LocationFilters, sort: string[], cached?: boolean): CustomAction<LocationPayload> => {
  return {
    type: FETCH_LOCATIONS,
    payload: { parentId, userId, page, search, filters, sort, cached }
  };
};

export const fetchLocationsSuccess = (locations: Location[], parent: Location | null, page: number, total: number): CustomAction<LocationPayload> => {
  return {
    type: FETCH_LOCATIONS_SUCCESS,
    payload: { locations, parent, page, total }
  };
};

export const fetchLocationsError = (): CustomAction<LocationPayload> => {
  return {
    type: FETCH_LOCATIONS_ERROR,
  };
};

export const setSelectAll = (selectAll: boolean): CustomAction<LocationPayload> => {
  return {
    type: SELECT_ALL_LOCATIONS,
    payload: { selectAll }
  };
};

export const setSelectRow = (select: boolean, locationId: string): CustomAction<LocationPayload> => {
  return {
    type: SELECT_LOCATION_ROW,
    payload: { select, locationId }
  };
};

export const createLocation = (partialLocation: Partial<Location>): CustomAction<LocationPayload> => {
  return {
    type: CREATE_LOCATION,
    payload: { partialLocation }
  };
};

export const createLocationSuccess = (): CustomAction<LocationPayload> => {
  return {
    type: CREATE_LOCATION_SUCCESS,
  };
};

export const createLocationError = (): CustomAction<LocationPayload> => {
  return {
    type: CREATE_LOCATION_ERROR,
  };
};

export const createBulkUnits = (unitNames: string[], parent: Location | null): CustomAction<LocationPayload> => {
  return {
    type: CREATE_BULK_UNITS,
    payload: {
      unitNames,
      parent
    }
  };
};

export const createBulkUnitsRequest = (): CustomAction<LocationPayload> => {
  return {
    type: CREATE_BULK_UNITS_REQUEST,
  };
};

export const createBulkUnitsSuccess = (): CustomAction<LocationPayload> => {
  return {
    type: CREATE_BULK_UNITS_SUCCESS,
  };
};

export const createBulkUnitsError = (): CustomAction<LocationPayload> => {
  return {
    type: CREATE_BULK_UNITS_ERROR,
  };
};

export const fetchUserLocations = (userId: string, types: LocationType[] = [], page: number = 1, search?: string, withRoles = false): CustomAction<LocationPayload> => {
  return {
    type: FETCH_USER_LOCATIONS,
    payload: { userId, types, page, search, withRoles }
  };
};

export const fetchUserLocationsSuccess = (locations: Location[], page: number, total: number): CustomAction<LocationPayload> => {
  return {
    type: FETCH_USER_LOCATIONS_SUCCESS,
    payload: { locations, page, total }
  };
};

export const fetchUserLocationsError = (): CustomAction<LocationPayload> => {
  return {
    type: FETCH_USER_LOCATIONS_ERROR,
  };
};

export const addToParent = (parentId: string, parentType: LocationType): CustomAction<LocationPayload> => {
  return {
    type: ADD_LOCATIONS_TO_PARENT,
    payload: { parentId, parentType }
  };
};

export const addToParentSuccess = (locationIds: string[]): CustomAction<LocationPayload> => {
  return {
    type: ADD_LOCATIONS_TO_PARENT_SUCCESS,
    payload: { locationIds }
  };
};

export const addToParentError = (): CustomAction<LocationPayload> => {
  return {
    type: ADD_LOCATIONS_TO_PARENT_ERROR,
  };
};

export const removeLocations = (): CustomAction<LocationPayload> => {
  return {
    type: REMOVE_LOCATIONS,
  };
};

export const removeLocationsSuccess = (): CustomAction<LocationPayload> => {
  return {
    type: REMOVE_LOCATIONS_SUCCESS,
  };
};

export const removeLocationsError = (): CustomAction<LocationPayload> => {
  return {
    type: REMOVE_LOCATIONS_ERROR,
  };
};

export const updateLocationSearch = (search: string): CustomAction<LocationPayload> => {
  return {
    type: UPDATE_LOCATION_SEARCH,
    payload: { search }
  };
};

export const updateLocationFilters = (filters: LocationFilters): CustomAction<LocationPayload> => {
  return {
    type: UPDATE_LOCATION_FILTERS,
    payload: { filters }
  };
};

export const fetchUserLocationsRoles = (authUserId: string, currentUserId: string, parentId: string | undefined, page: number, search: string, filters: LocationFilters): CustomAction<LocationPayload> => {
  return {
    type: FETCH_USER_LOCATIONS_ROLES,
    payload: { authUserId, currentUserId, parentId, page, search, filters }
  };
};

export const fetchUserLocationsRolesSuccess = (locations: Location[], parent: Location | null, page: number, total: number): CustomAction<LocationPayload> => {
  return {
    type: FETCH_USER_LOCATIONS_ROLES_SUCCESS,
    payload: { locations, parent, page, total }
  };
};

export const fetchUserLocationsRolesError = (): CustomAction<LocationPayload> => {
  return {
    type: FETCH_USER_LOCATIONS_ROLES_ERROR,
  };
};

export const setCurrentLocation = (currentLocation: Location | null): CustomAction<LocationPayload> => {
  return {
    type: SET_CURRENT_LOCATION,
    payload: { currentLocation }
  };
};

export const editLocation = (partialLocation: Partial<Location>): CustomAction<LocationPayload> => {
  return {
    type: EDIT_LOCATION,
    payload: { partialLocation }
  };
};

export const editLocationSuccess = (): CustomAction<LocationPayload> => {
  return {
    type: EDIT_LOCATION_SUCCESS,
  };
};

export const editLocationError = (): CustomAction<LocationPayload> => {
  return {
    type: EDIT_LOCATION_ERROR,
  };
};

export const setLocationSystemModeBulk = (systemModeTarget: SystemMode, revertMinutes?: number): CustomAction<LocationPayload> => {
  return {
    type: SET_LOCATION_SYSTEM_MODE_BULK,
    payload: { revertMinutes, systemModeTarget }
  };
};

export const setLocationSystemModeBulkSuccess = (changedLocationIds: string[], newMode: SystemMode): CustomAction<LocationPayload> => {
  return {
    type: SET_LOCATION_SYSTEM_MODE_BULK_SUCCESS,
    payload: { changedLocationIds, newMode }
  };
};

export const incrementLocationPage = (): CustomAction<LocationPayload> => {
  return {
    type: INCREMENT_LOCATION_PAGE,
  };
};

export const reinitLocationPageCount = (): CustomAction<LocationPayload> => {
  return {
    type: REINIT_LOCATION_PAGE_COUNT,
  };
};

export const fetchLocationFacets = (facet: LocationFacet): CustomAction<LocationPayload> => {
  return {
    type: FETCH_LOCATIONS_FACETS,
    payload: { facet }
  };
};

export const fetchLocationFacetsSuccess = (facetValues: LocationFacetsState): CustomAction<LocationPayload> => {
  return {
    type: FETCH_LOCATIONS_FACETS_SUCCESS,
    payload: { facetValues }
  };
};

export const fetchLocationFacetsError = (): CustomAction<LocationPayload> => {
  return {
    type: FETCH_LOCATIONS_FACETS_ERROR,
  };
};

export const setShowLocationFilters = (show: boolean): CustomAction<LocationPayload> => {
  return {
    type: UPDATE_SHOW_LOCATION_FILTERS,
    payload: { show }
  };
};

export const setSingleSelectLocation = (location: Location): CustomAction<LocationPayload> => {
  return {
    type: SET_SINGLE_SELECT_LOCATION,
    payload: { location }
  }
}

export const removeSingleSelectLocation = (location: Location): CustomAction<LocationPayload> => {
  return {
    type: REMOVE_SINGLE_SELECT_LOCATION,
    payload: { location }
  }
}
